import { http } from '@/utils/http'
import { FilterMemberEnabledModules, MemberEnabledModulesVo } from './memberModulesType'

/**
 * 获取会员端模块开关状态
 */
export function requestGetMemberEnabledModules(data: FilterMemberEnabledModules) {
  return http.get<MemberEnabledModulesVo>('/members/modules/enabled-status', data)
}
